import { Component } from "react";
import { configSettings } from "../../config/configSettings";
import { Constants } from '../../config/appConstants';
 
// let headers = new Headers();
// headers.append('Content-Type', 'application/json');
// headers.append('Accept', 'application/json');

export default class Api extends Component {

    static Get(url, componentState, isShowLoader = true,isShowLoaderEnabled=false) {
        componentState.setState({ isShowLoader: isShowLoader });
        url = configSettings.environment + url;
        let headers = { Pragma: 'no-cache' };
        if (componentState && componentState.props && componentState.props.user && componentState.props.user.accessToken && componentState.props.user.accessToken !== "") {
            headers = { ...headers, [Constants.AUTHORIZATION]: Constants.BEARER + Constants.SPACE + componentState.props.user.accessToken };
        }
        return new Promise((resolve) => {
            const options = {
                method: 'GET',
                headers
            };
            return fetch(url, options).then((response) => {
                    componentState.setState({ isShowLoader: isShowLoaderEnabled });            
                if(response.status === 401){
                    componentState.props.logout();
                    componentState.props.history.push('/Login');
                }else{
                    return resolve(response.json());
                }                
            }).catch(error => {
                componentState.setState({ isShowLoader: isShowLoaderEnabled });
                if(error.message===Constants.FAILED_TO_FETCH){
                    error.message= Constants.PLEASE_CHECK_INTERNET_CONNECTION;
                } 
                return resolve(error);
            });
        });
    }

    static Post(url, data, componentState, isShowLoader = true,isShowLoaderEnabled=false) {
        componentState.setState({ isShowLoader: isShowLoader });
        url = configSettings.environment + url;
        let headers = {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            };
        if (componentState && componentState.props && componentState.props.user && componentState.props.user.accessToken && componentState.props.user.accessToken !== "") {
            headers = { ...headers, [Constants.AUTHORIZATION]: Constants.BEARER + Constants.SPACE + componentState.props.user.accessToken };
        }
        return new Promise((resolve) => {
            const options = {
                method: 'POST',
                headers,
                body: JSON.stringify(data)
            };
            return fetch(url, options).then((response) => {
                componentState.setState({ isShowLoader: isShowLoaderEnabled });
                if(response.status === 401){
                    componentState.props.logout();
                    componentState.props.history.push('/Login');
                }else{
                    return resolve(response.json());
                }
            }).catch(error => {
                componentState.setState({ isShowLoader: isShowLoaderEnabled });
                if(error.message===Constants.FAILED_TO_FETCH){
                    error.message=Constants.PLEASE_CHECK_INTERNET_CONNECTION;
                }
                return resolve(error);
            });
        });
    }
}